if (!customElements.get('mini-curler-price')) {
  customElements.define('mini-curler-price', class extends HTMLElement {
    connectedCallback() {
      this.quantityInput = this.closest('product-info')?.querySelector('.quantity__input');
      if (!this.quantityInput) return;

      try {
        this.formatter = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency,
          currencyDisplay: 'symbol',
        });
      } catch {
        return; // Keep the server-rendered price if currency data is unavailable.
      }

      this.onQuantityChange = this.update.bind(this);
      this.quantityInput.addEventListener('input', this.onQuantityChange);
      this.quantityInput.addEventListener('change', this.onQuantityChange);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChange);
      this.update();
    }

    disconnectedCallback() {
      this.quantityInput?.removeEventListener('input', this.onQuantityChange);
      this.quantityInput?.removeEventListener('change', this.onQuantityChange);
      this.unsubscribe?.();
    }

    update() {
      const quantity = Number(this.quantityInput.value);
      const unitPrice = Number(this.dataset.unitPrice);
      const discount = Number(quantity >= 3 ? this.dataset.threeDiscount || 0 : quantity === 2 ? this.dataset.twoDiscount || 0 : 0);
      if (!Number.isSafeInteger(discount) || discount < 0 || discount > 100) return;
      const total = (unitPrice - Math.floor(unitPrice * discount / 100)) * quantity;
      if (!Number.isSafeInteger(quantity) || quantity < 1 ||
          !Number.isSafeInteger(unitPrice) || unitPrice < 0 || !Number.isSafeInteger(total)) return;

      // Liquid prices use integer hundredths, including zero-decimal currencies.
      let price = this.formatter.format(total / 100);
      if (this.dataset.currencyCode === 'true' && !price.includes(this.dataset.currency)) {
        price += ` ${this.dataset.currency}`;
      }
      this.textContent = price;
    }
  });
}
